module.exports = __webpack_public_path__ + "225e20b37eeb24117ffbf50984558667.fbx";